let k = window.matchMedia('(min-width: 1024px)').matches ? '-40' : '0';
let rootMargin;
const revealItemsObserver = new IntersectionObserver(
    (entries) => {
        entries.forEach((entry) => {
            rootMargin = entry.target.dataset.rootMargin ? entry.target.dataset.rootMargin : `${k}%`;
            if (entry.isIntersecting) {
                if (entry.target.dataset.revealRepeat !== 'true') {
                    revealItemsObserver.unobserve(entry.target);
                }

                entry.target.classList.add('is-revealed');
            }

            if (entry.target.dataset.revealRepeat === 'true') {
                if (!entry.isIntersecting) {
                    entry.target.classList.remove('is-revealed');
                }
            }
        });
    },
    {
        rootMargin,
    },
);

function onResize() {
    k = window.matchMedia('(min-width: 1024px)').matches ? '-10' : '0';
}

function init(container: HTMLElement | Document = document) {
    Array.from(container.querySelectorAll('.js-reveal')).forEach((el) => {
        revealItemsObserver.observe(el);
    });
    const footer: HTMLElement | null = document.querySelector('.js-footer');
    if (footer) {
        revealItemsObserver.observe(footer);
        const footerRevealItems = footer.querySelectorAll('.js-reveal');
        footerRevealItems.forEach((el) => revealItemsObserver.observe(el));
    }
    window.addEventListener('resize', onResize);
}

function destroy(container: HTMLElement | Document = document) {
    Array.from(container.querySelectorAll('.js-reveal')).forEach((el) => {
        revealItemsObserver.unobserve(el);
    });
    const footer: HTMLElement | null = document.querySelector('.js-footer');
    if (footer) {
        revealItemsObserver.unobserve(footer);
        const footerRevealItems = footer.querySelectorAll('.js-reveal');
        footerRevealItems.forEach((el) => revealItemsObserver.unobserve(el));
    }
    window.removeEventListener('resize', onResize);
}

const _module = { init, destroy };

export default _module;
